export class AppSettings {
    // public defaultAPIURLHost: string = "http://localhost:53129";
    public defaultAPIURLHost: string = "https://liteclerk-crm-api.liteclerk.com";
}
